import script from "./TrafficTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficTab.vue?vue&type=script&setup=true&lang=js"

import "./traffic/traffic-dashboard.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__